import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Booking } from '@/types';

interface ClipboardContextType {
  copiedBooking: Booking | null;
  copyBooking: (booking: Booking) => void;
  clearClipboard: () => void;
}

const ClipboardContext = createContext<ClipboardContextType | undefined>(undefined);

export function ClipboardProvider({ children }: { children: ReactNode }) {
  const [copiedBooking, setCopiedBooking] = useState<Booking | null>(null);

  const copyBooking = (booking: Booking) => {
    console.log('ClipboardContext: copyBooking called with:', booking);
    setCopiedBooking(booking);
    console.log('ClipboardContext: copiedBooking state will be updated');
  };

  const clearClipboard = () => {
    setCopiedBooking(null);
  };

  return (
    <ClipboardContext.Provider value={{ copiedBooking, copyBooking, clearClipboard }}>
      {children}
    </ClipboardContext.Provider>
  );
}

export function useClipboard() {
  const context = useContext(ClipboardContext);
  if (context === undefined) {
    throw new Error('useClipboard must be used within a ClipboardProvider');
  }
  return context;
}
